import SignInForm from "./fragments/SignInForm";
import AuthShell from "./Layout/AuthShell";

const SignIn: React.FC<{ disableCustomTheme?: boolean }> = () => (
  <AuthShell>
    <SignInForm />
  </AuthShell>
);

export default SignIn;
